import React, { Fragment, useEffect } from "react"
import { site } from "config/app";

const PublicLayout = ({children}) => {

  useEffect(() => {
    document.title = site.title
  })

  return (
    <Fragment>{children}</Fragment>
  )

}
export default PublicLayout
